import { CALL_API } from '../middleware/api';
import {
    GET_NOTIFICATION_TEMPLATES_REQUEST,
    GET_NOTIFICATION_TEMPLATES_SUCCESS,
    GET_NOTIFICATION_TEMPLATES_FAILURE,
} from './actionTypes';
import NotificationTemplatesClient from '../lib/apiClients/roofSnapApiClient/notificationTemplatesClient';
import QueryStringBuilder from '../lib/queryStringBuilder';

export const getNotificationTemplates = (page = 1) => {
    const client = new NotificationTemplatesClient('v1');
    const request = client.getNotificationTemplates;

    const queryStringBuilder = new QueryStringBuilder();
    queryStringBuilder.setQueryParameter('page', page);
    const queryParams = queryStringBuilder.buildQueryString();

    return {
        [CALL_API]: {
            types: [
                GET_NOTIFICATION_TEMPLATES_REQUEST,
                GET_NOTIFICATION_TEMPLATES_SUCCESS,
                GET_NOTIFICATION_TEMPLATES_FAILURE,
            ],
            request,
            params: {
                queryParams,
            },
        }
    }
};
